define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Layer = (function () {
        function Layer() {
            this.Name = "";
            this.zIndex = 0;
            this.ViewPorts = [];
        }
        return Layer;
    }());
    exports.Layer = Layer;
});
//# sourceMappingURL=Layer.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/Layer.js
// module id = 372
// module chunks = 0